import NetworkIndicator from "@components/NetworkIndicator";
import { ToastConfig } from "@components/Toast";
import colors from "@constants/color";
import { fetchConfig } from "@services/firebase";
import React, { Component } from "react";
import { StyleSheet, Text } from "react-native";
import GlobalFont from "react-native-global-font";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { MenuProvider } from "react-native-popup-menu";
import Toast from "react-native-toast-message";
import RootNavigation from "./navigation";

fetchConfig().catch((e) => {
  console.log(e);
});

class Main extends Component {
  async componentDidMount() {
    if (Text.defaultProps == null) {
      Text.defaultProps = {};
    }
    Text.defaultProps.allowFontScaling = false;
    const fontName = "NotoSansDevanagari-Regular";
    GlobalFont.applyGlobal(fontName);
  }

  render() {
    return (
      <GestureHandlerRootView style={{ flex: 1 }}>
        <MenuProvider customStyles={menuProviderStyles} backHandler={true}>
          <RootNavigation />
          <NetworkIndicator />
          <Toast config={ToastConfig} />
        </MenuProvider>
      </GestureHandlerRootView>
    );
  }
}

export default Main;

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  backdrop: {
    backgroundColor: colors.mediumBlack,
    opacity: 0.5,
  },
});

const menuProviderStyles = {
  menuProviderWrapper: styles.container,
  backdrop: styles.backdrop,
};
